/*
 events api
*/

import axios from '../axios/axios';

export function saveEventApi(params) {
  return axios.post('/events/saveEvent', params);
}

export function addKeywordEventApi(params) {
  return axios.post('/events/addKeyword', params);
}

export function removeKeywordEventApi(params) {
  return axios.post('/events/removeKeyword', params);
}

export function getEventsApi(params) {
  return axios.post('/events/get', params);
}

export function removeEventsApi(params) {
  return axios.post('/events/removeEvent', params);
}

export function listEventKeywordsApi(params) {
  return axios.post('/events/listEventKeywords', params);
}

export function getEventPostsApi(params) {
  return axios.post('/events/getEventPosts', params);
}

export function getThreadEventsApi(params) {
  return axios.post('/events/getThreadEvents', params);
}

export function addPostEventApi(params) {
  return axios.post('/events/addPost', params);
}




